(() => {
  if (window.TDFWCollectionReference) return;
  window.TDFWCollectionReference = true;
  function syncCounts() {
    document.querySelectorAll('.cpr-collection-reference').forEach(root => {
      const count = root.querySelector('[data-cpr-result-count]');
      const heading = root.querySelector('[data-cpr-heading-count]');
      if (count && heading) heading.textContent = count.dataset.cprResultCount;
    });
  }
  document.addEventListener('filters-applied', syncCounts);
  document.addEventListener('shopify:section:load', syncCounts);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCounts);
  else syncCounts();
})();
